export default __webpack_public_path__ + "static/media/logoutblack.3ac721c2.png";